export const LogoutTypeMaintenance = 'LOGOUT_TYPE_MAINTENANCE';
export const IssuingAuthorityNative = 'ISSUING_AUTHOURITY_NATIVE';
export const IssuingAuthorityAuth0 = 'ISSUING_AUTHOURITY_AUTH0';
export const IssuingAuthorityNone = 'ISSUING_AUTHOURITY_NONE';
export const ActiveIdentityProviders = ['google-oauth2'];

export const AUTH0_MFA_TYPES = {
  email: 'email',
  sms: 'sms',
  voice: 'voice',
  totp: 'totp',
};

export const PHONE_VERIFICATION_STATES = {
  START: 'start',
  BANNER: 'banner',
  MODAL: 'modal',
  UNSKIPPABLE: 'unskippable',
  VERIFIED: 'verified',
  BYPASSED_VIA_OTP: 'bypassed_via_otp',
  BANNER_DISMISSED: 'banner_dismissed',
  MODAL_DISMISSED: 'modal_dismissed',
};
